import { Grid, IconButton, TextField, Tooltip } from "@mui/material";
import { AddBox, IndeterminateCheckBox } from "@mui/icons-material";
import { t } from "i18next";
import "./inputPlus.css";

function AddDomainForm({ items, error, label, classes, disabled, handleChange, grid_md }) {

  const handleItemsChange = (op, i, value) => {
    const tempArr =  [...items];
    switch (op) {
      case "change":
        tempArr[i] = value;
        break;
      case "add":
        tempArr.push("");
        break;
      case "remove":
        tempArr.splice(i, 1);
    }
    handleChange(tempArr);
  };

  return (
     <>
       {items.map((item, i) => {
         return (
            <Grid item md={grid_md ? grid_md : 5} xs={12} className="add-item-name" key={i}>
              <TextField id={`item_${i}`} label={label} variant="outlined" disabled={disabled}
                         className={classes} sx={{ mt: error && error[i] ? 2 : 0 }}
                         value={item} error={!!(error && error[i])} helperText={error && error[i]}
                         onChange={(e) => handleItemsChange("change", i, e.target.value)}
              />

              {!disabled &&
                 <>
                   {i === items.length-1
                      ? (
                         <Tooltip placement="top"
                                  title={t("button.plus", { item: label })}
                         >
                           <IconButton color="success" aria-label="add" onClick={() => handleItemsChange("add")}>
                             <AddBox />
                           </IconButton>
                         </Tooltip>
                      )
                      : (
                         <Tooltip placement="top"
                                  title={t("button.minus", { item: label })}
                         >
                           <IconButton color="error" aria-label="remove" onClick={() => handleItemsChange("remove", i, "")}>
                             <IndeterminateCheckBox />
                           </IconButton>
                         </Tooltip>
                      )
                   }
                 </>
              }
            </Grid>
         )
       })}
     </>
  );
}

export default AddDomainForm;
